import { lazy, Suspense } from "react";
import { useWidgetZonesEnabled } from "@/hooks/useWidgetZonesEnabled";

interface WidgetZoneProps {
  zone: string;
  pageSlug?: string;
  className?: string;
}

const WidgetZoneImpl = lazy(() => import("./WidgetZoneImpl"));

/**
 * Lightweight shell. When no published widget zones exist (checked once per
 * session), this returns null and ships no zone-rendering JS, no Supabase
 * queries, and no DOM image-rewrite work.
 */
export default function WidgetZone(props: WidgetZoneProps) {
  const enabled = useWidgetZonesEnabled();
  if (!enabled) return null;
  return (
    <Suspense fallback={null}>
      <WidgetZoneImpl {...props} />
    </Suspense>
  );
}
